import { render, staticRenderFns } from "./VanillaItem.vue?vue&type=template&id=48d1e0c5"
import script from "./VanillaItem.vue?vue&type=script&lang=js"
export * from "./VanillaItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports